import React, { useContext, useRef, useEffect } from 'react'
// @mui material components
import Grid from '@mui/material/Grid'

// Settings page components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import Sidenav from './components/Sidenav'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { IntakeContext } from 'context/IntakeContext'

//Section Components
import BasicInfo from './components/BasicInfo'
import EmploymentDetails from './components/EmploymentDetails'
import MilitaryDetails from './components/MilitaryDetails'
import PayStubDetails from './components/PayStubDetails'
import Deductions from './components/Deductions'
import SocialSecurity from './components/SocialSecurity'
import LifeInsurance from './components/LifeInsurance'
import Tsp from './components/Tsp'
import Family from './components/Family'
import Healthcare from './components/Healthcare'
import Retirement from './components/Retirement'
import Other from './components/Other'
import Component401k from './components/401k'

function Profile() {
  const { intakeState } = useContext(IntakeContext)
  const isGovernmentEmployee = intakeState?.governmentEmployee
  const isMobile = useMediaQuery('(max-width:1200px)')

  const containerRef = useRef()
  const sidenavRef = useRef()

  const resizeTimeoutRef = useRef(null)

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current)
      }

      resizeTimeoutRef.current = setTimeout(() => {
        // console.log('OBSERVED CHANGE')
        if (sidenavRef.current) {
          sidenavRef.current.updateTabLocations()
        }
      }, 1000)
    })

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current)
      }

      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current)
      }
    }
  }, [])
  const retirementDetails = (
    <Grid
      sx={{ scrollMarginTop: 75 }}
      className={'settings-tab'}
      id={'retirement-details'}
      item
      xs={12}
    >
      {isGovernmentEmployee ? <Tsp /> : <Component401k />}
    </Grid>
  )
  return (
    <DashboardLayout>
      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
        pb={6}
      >
        <Grid item xs={12} mb={{ xs: -2, lg: 4 }} mt={8} display={'flex'}>
          <Typography
            fontWeight="400"
            fontSize="28px"
            textAlign="left"
            color="#262627"
          >
            <Box sx={{ display: 'inline-block', fontWeight: 600 }}>Profile</Box>{' '}
            - Edit any of your info below:
          </Typography>
        </Grid>
        <Grid container ref={containerRef} spacing={{ xs: 1, xl: 6 }}>
          <Grid
            sx={{
              backgroundColor: '#f8f9fa',
              position: 'sticky',
              height: '100%',
              marginTop: '16px',
            }}
            pt={{
              xs: '32px !important',
              lg: '0px !important',
              xl: '32px !important',
            }}
            top={0}
            zIndex={5}
            pb={2}
            item
            xs={12}
            xl={3}
          >
            <Sidenav
              ref={sidenavRef}
              isMobile={isMobile}
              isGovernmentEmployee={isGovernmentEmployee}
            />
          </Grid>

          <Grid item xs={12} xl={9} margin="auto">
            <Box>
              <Grid container spacing={{ xs: 1, lg: 3 }}>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'basic-info'}
                  item
                  xs={12}
                >
                  <BasicInfo />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'employment'}
                  item
                  xs={12}
                >
                  <EmploymentDetails />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'military'}
                  item
                  xs={12}
                >
                  <MilitaryDetails />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'family'}
                  item
                  xs={12}
                >
                  <Family />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'paystub'}
                  item
                  xs={12}
                >
                  <PayStubDetails />
                </Grid>
                {isGovernmentEmployee && (
                  <Grid
                    sx={{ scrollMarginTop: 75 }}
                    className={'settings-tab'}
                    id={'deductions'}
                    item
                    xs={12}
                  >
                    <Deductions />
                  </Grid>
                )}
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'healthcare'}
                  item
                  xs={12}
                >
                  <Healthcare />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'lifeinsurance'}
                  item
                  xs={12}
                >
                  <LifeInsurance />
                </Grid>
                {isGovernmentEmployee && (
                  <Grid
                    sx={{ scrollMarginTop: 75 }}
                    className={'settings-tab'}
                    id={'retirement'}
                    item
                    xs={12}
                  >
                    <Retirement />
                  </Grid>
                )}
                {retirementDetails}
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'socialsecurity'}
                  item
                  xs={12}
                >
                  <SocialSecurity />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'other'}
                  item
                  xs={12}
                >
                  <Other />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </DashboardLayout>
  )
}

export default React.memo(Profile)
